<div class="wrapper">
    <div class="header">
        <app-section-header [title]="'Buildings'" [iconName]="'buildings'" [actionsTemplate]="actionsTemplate">
            <ng-template #actionsTemplate>
                <div class="actions">
                    <button class="primary-btn" (click)="onCreateNewBuildingClicked()">
                        <span class="icon" [innerHTML]="plusIcon"></span> New Building
                    </button>
                </div>
            </ng-template>
        </app-section-header>

        <div class="filters">
            <app-buildings-filters></app-buildings-filters>
        </div>
    </div>

    <div class="tabGroup">
        <lib-tab-view [(currentTab)]="currentTab" [hasSteps]="false" [alignment]="'end'">
            <lib-tab-item tabName="List" [bodyTemplate]="list" [icon]="listIcon">
                <ng-template #list>
                    <div class="tab">
                        <app-buildings-list></app-buildings-list>
                    </div>
                </ng-template>
            </lib-tab-item>

            <lib-tab-item tabName="Map" [bodyTemplate]="map" [icon]="mapIcon">
                <ng-template #map>
                    <div class="tab">
                        <app-buildings-map></app-buildings-map>
                    </div>
                </ng-template>
            </lib-tab-item>
        </lib-tab-view>
    </div>
</div>
